import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import {
    getJsonPayload,
    getPageInfo,
    getUserInfo
} from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

const getEventType = (element: HTMLElement) => {
    return (
        (element?.dataset?.trackingEvent as EventType | undefined) ||
        EventType.NONE
    );
};

const getPlacement = (element: HTMLElement): string => {
    const closestSection = element.closest("section[data-tracking-info]");

    const placement = closestSection
        ? getJsonPayload(closestSection as HTMLElement)?.name
        : "";

    return placement;
};

const getTrackingInfo = (element: HTMLElement) => {
    const href =
        element instanceof HTMLAnchorElement ? element?.href : undefined;

    const model: ClickTrackingInfo = {
        category: element?.className || "",
        name: element?.title || element?.innerText || "",
        targetUrl: href,
        targetName: href
    };

    return model;
};

const track = (eventType: EventType, trackingInfo: ClickTrackingInfo) => {
    const event: TypedAnalyticsEvent<ClickTrackingInfo> = {
        event: eventType,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackElement = <TElement extends HTMLElement>(
    eventType: EventType,
    trackingInfo: ClickTrackingInfo,
    element: TElement
) => {
    const placement = trackingInfo.placement || getPlacement(element);

    track(eventType, {
        ...trackingInfo,
        placement: placement
    });
};

export const trackElementWithAttributes = (
    element: HTMLElement,
    anchorElement?: HTMLAnchorElement
) => {
    const eventType = getEventType(element);

    const trackingInfo: ClickTrackingInfo = {
        ...getTrackingInfo(anchorElement ?? element),
        ...getJsonPayload(element),
        placement: getPlacement(element)
    };

    track(eventType, trackingInfo);
};
